import React from 'react';
import Modal from './Modal';

const BatchProgressOverlay = ({
    visible,
    progress = 0,
    status,
    currentBatch = 0,
    totalBatches = 0,
    currentPatterns = [],
}) => {
    const pct = Math.max(0, Math.min(100, Number(progress) || 0));
    const showBatch = totalBatches > 0;
    const showPatterns = currentPatterns && currentPatterns.length > 0;

    return (
        <Modal
            open={visible}
            kicker="Working"
            title="Searching traders."
            closable={false}
            width={460}
        >
            <div className="fs-progress">
                <div className="row">
                    <span className="lbl">Progress</span>
                    <span className="pct">{Math.round(pct)}%</span>
                </div>
                <div className="fs-progress-track">
                    <span
                        className={`fs-progress-bar${pct === 0 ? ' indeterminate' : ''}`}
                        style={pct === 0 ? undefined : { width: `${pct}%` }}
                    />
                </div>
                {showBatch && (
                    <span className="fs-progress-meta">
                        Batch {currentBatch} of {totalBatches}
                    </span>
                )}
                {status && (
                    <span
                        className="fs-progress-meta"
                        style={{ color: 'var(--ink-2)' }}
                    >
                        {status}
                    </span>
                )}
                {showPatterns && (
                    <span className="fs-progress-meta">
                        Patterns · {currentPatterns.join(', ')}
                    </span>
                )}
            </div>
        </Modal>
    );
};

export default BatchProgressOverlay;
